import { createStore } from "vuex";

export default createStore({
  state: {
    loading: {
      show: false,
    },
    toast: {
      show: false,
      text: "",
    },
    auth: {
      isLogged: false,
      user: null,
      isAdmin: false,
    },
  },
  mutations: {
    logIn(state, user) {
      state.auth.isLogged = true;
      state.auth.user = user;
    },
    logOut(state) {
      state.auth.isLogged = false;
      state.auth.user = null;
    },
  },
  actions: {},
  modules: {},
});
